<template>
  <div class="ticket-manage">
    <div class="manage-query">
      <el-form
        :inline="true"
        :model="query"
        ref="queryForm"
        size="small"
        class="query-middle"
      >
        <el-form-item label="景点名：" prop="ProjectName">
          <el-input v-model="query.ProjectName"></el-input>
        </el-form-item>
        <el-form-item label="创建时间：" prop="StartTime">
          <el-date-picker
            v-model="query.StartTime"
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 200px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="—" prop="EndTime">
          <el-date-picker
            v-model="query.EndTime"
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 200px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getData"
            >搜索</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button
            type="info"
            icon="el-icon-circle-close"
            @click="resetForm('queryForm')"
            >清除</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="manage-content">
      <div class="main-left">
        <div class="main-title">
          <span> <i class="el-icon-folder-opened"></i>景区/景点列表 </span>
          <el-button-group>
            <!-- <el-button icon="el-icon-folder-opened" @click="exportTable" size="mini" v-if="false">导出</el-button> -->
            <el-button
              icon="el-icon-circle-plus-outline"
              type="primary"
              size="mini"
              @click="model.visible = true"
              >新增</el-button
            >
          </el-button-group>
        </div>
        <div class="left-table">
          <el-table :data="tableData" height="753px" border style="width: 100%">
            <!-- @selection-change="handleSelectionChange" -->
            <el-table-column
              type="selection"
              min-width="10"
              align="center"
            ></el-table-column>
            <el-table-column
              label="名称"
              prop="ProjectName"
              min-width="150"
              align="center"
            ></el-table-column>
            <el-table-column
              label="类型"
              prop="Type"
              min-width="100"
              align="center"
            >
              <!-- <template slot-scope="scope">
                <span>{{scope.row.PointId | typeFormat(model.scenicTypes)}}</span>
              </template>-->
            </el-table-column>
            <!-- <el-table-column label="价格" prop="Price" min-width="200" align="center"></el-table-column> -->
            <el-table-column
              label="地址"
              prop="Address"
              min-width="140"
              align="center"
            ></el-table-column>
             <el-table-column label="创建时间" prop="ApplyTime" min-width="140" align="center">
                <template slot-scope="scope">
                <p>{{scope.row.ApplyTime | dateFormat}}</p>
              </template>
            </el-table-column>
            <el-table-column
              label="状态"
              prop="Status"
              min-width="90"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-tag
                  :type="scope.row.Status | keyToVal(statusType)"
                  effect="dark"
                  size="small"
                  >{{ scope.row.Status | keyToVal(normalStatus) }}</el-tag
                >
              </template>
            </el-table-column>
            <!-- <el-table-column label="操作日期" prop="ApplyTime" min-width="200" align="center"></el-table-column> -->
            <el-table-column
              label="操作"
              min-width="200"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-row type="flex" justify="space-between">
                  <el-button
                    size="mini"
                    type="primary"
                    v-on:click.stop="getDetail(scope.row)"
                    v-show="scope.row.Status === 0"
                    >查看</el-button
                  >
                  <el-button-group>
                    <el-button
                      v-show="scope.row.Status === 0"
                      size="mini"
                      type="warning"
                      @click="changeState(scope.row.Id, 1)"
                      >禁用</el-button
                    >
                    <el-button
                      v-show="scope.row.Status === 1"
                      size="mini"
                      type="success"
                      @click="changeState(scope.row.Id, 0)"
                      >启用</el-button
                    >
                    <el-popconfirm
                      title="确认删除吗？"
                      v-on:onConfirm="changeState(scope.row.Id, -1)"
                      v-show="scope.row.Status !== -1"
                    >
                      <el-button size="mini" type="danger" slot="reference"
                        >删除</el-button
                      >
                    </el-popconfirm>
                  </el-button-group>
                </el-row>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="left-pagination">
          <el-pagination
            class="pagination-bottom"
            background
            layout="prev, pager, next, total,sizes,jumper"
            :total="total"
            :page-size="query.PageSize"
            :page-sizes="[10, 20, 50]"
            :current-page.sync="query.PageIndex"
            v-on:size-change="handlePageSize"
            v-on:current-change="handlePageIndex"
          ></el-pagination>
        </div>
      </div>
      <div class="main-right">
        <div class="main-title">
          <span> <i class="el-icon-document"></i> 查看 </span>
          <el-button-group>
            <el-button
              type="warning"
              v-show="flag === 1"
              size="mini"
              @click="flag = 2"
              >编辑</el-button>
            <el-button
              type="success"
              v-show="flag === 2"
              size="mini"
              @click="save('updateForm')"
              >保存</el-button>
          </el-button-group>
        </div>
        <div class="right-table">
          <table class="input-form" v-show="flag === 1">
            <thead>
              <tr>
                <th colspan="2">景区点信息</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>景区点名称</td>
                <td>{{ detail.ProjectName }}</td>
              </tr>
              <tr>
                <td>景区点类型</td>
                <td>{{ detail.Type }}</td>
              </tr>
              <tr>
                <td>景区点地址</td>
                <td>{{ detail.Address }}</td>
              </tr>
              <tr>
                <td>景区点门票（元）</td>
                <td>{{ detail.Price }}</td>
              </tr>
              <!-- <tr>
                <td>创建日期</td>
                <td>{{ detail.ApplyTime | dateFormat }}</td>
              </tr> -->
              <tr>
                <td>备注</td>
                <td>{{ detail.Remarks }}</td>
              </tr>
              <tr>
                <td>状态</td>
                <td>{{ detail.Status | keyToVal(normalStatus) }}</td>
              </tr>
            </tbody>
          </table>
          <!-- 编辑表单 -->
          <ValidationObserver ref="updateForm">
            <table class="input-form" v-show="flag === 2">
              <thead>
                <tr>
                  <th colspan="2">景区点信息（修改）</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>景区点名称</td>
                  <td>
                    <ValidationProvider rules="required">
                      <el-input
                        v-model="detail.ProjectName"
                        placeholder="请输入景点名"
                      ></el-input>
                    </ValidationProvider>
                  </td>
                </tr>
                <tr>
                  <td>景区点类型</td>
                  <td>
                    <ValidationProvider rules="required">
                      <el-select v-model="detail.Type" placeholder="请选择">
                        <el-option
                          :label="item"
                          :value="item"
                          :key="index"
                          v-for="(item, index) in pointTypes"
                        ></el-option>
                      </el-select>
                    </ValidationProvider>
                  </td>
                </tr>
                <tr>
                  <td>景区点地址</td>
                  <td>
                    <ValidationProvider rules="required">
                      <el-input
                        v-model="detail.Address"
                        placeholder="请输入"
                      ></el-input>
                    </ValidationProvider>
                  </td>
                </tr>
                <tr>
                  <td>景区点门票（元）</td>
                  <td>
                    <el-input-number
                      v-model="detail.Price"
                      :precision="2"
                      :step="0.1"
                      :min="0"
                      placeholder="请输入"
                    ></el-input-number>
                  </td>
                </tr>
                <tr>
                  <td>备注</td>
                  <td>
                    <el-input
                      v-model="detail.Remarks"
                      placeholder="请输入"
                    ></el-input>
                  </td>
                </tr>
                <tr>
                  <td>状态</td>
                  <td>
                    <el-select v-model="detail.Status">
                      <el-option
                        v-for="item in normalStatus"
                        :key="item.key"
                        :label="item.val"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </td>
                </tr>
              </tbody>
            </table>
          </ValidationObserver>
        </div>
      </div>
    </div>
    <!-- 添加模态框 -->
    <el-dialog
      @closed="resetForm('postForm')"
      title="新增景区/景点"
      :visible.sync="model.visible"
      :close-on-click-modal="false"
      width="600px"
    >
      <el-form
        ref="postForm"
        :model="model.form"
        :rules="model.rules"
        label-width="120px"
      >
        <el-form-item label="名称" prop="ProjectName">
          <el-input v-model="model.form.ProjectName"></el-input>
        </el-form-item>
        <el-form-item label="地址" prop="Address">
          <el-input v-model="model.form.Address"></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="Type">
          <el-select v-model="model.form.Type" placeholder="请选择">
            <el-option
              :label="item"
              :value="item"
              :key="index"
              v-for="(item, index) in pointTypes"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="门票价格" prop="Price">
          <el-input-number
            v-model="model.form.Price"
            :precision="2"
            :step="0.1"
            :min="0"
            placeholder="请输入"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="备注" prop="Remarks">
          <el-input
            v-model="model.form.Remarks"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="model.visible = false">取 消</el-button>
        <el-button type="primary" @click="postModel('postForm')">确 定</el-button>
      </span>
    </el-dialog>

   
  </div>
</template>
<script>
import { keyToVal, dateFormat } from "@/filters/filters";
import POINT from "@/api/point";
import ValidationProvider from "@/common/vee-validator";
import { ValidationObserver } from "vee-validate";
// import Attachment from "@/api/common";
import { mapState } from "vuex";
export default {
  name: "PointManage",
  inject: ["voucher", "complementPicUrl", "deepClone"], //,
  data() {
    return {
      query: {
        ProjectName: "",
        StartTime: "",
        EndTime: "",
        PageSize: 10,
        PageIndex: 1,
      },
      //景点总数，分页用等
      total: 0,
      detail: {},
      model: {
        form: {
          ProjectName: "",
          Type: "",
          Price: "",
          Address: "",
          Remarks: "",
        },
        rules: {
          ProjectName: [
            { required: true, message: "请输入名称", trigger: "blur" },
          ],
          Type: [{ required: true, message: "请选择类型", trigger: "blur" }],
          Address: [{ required: true, message: "请输入地址", trigger: "blur" }],
        },
        visible: false,
      },
     
      flag: 0,
      tableData: [],
    };
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    ...mapState("common", ["normalStatus", "statusType", "pointTypes"]),
  },
  filters: {
    keyToVal,
    dateFormat,
  },
  methods: {
    //清除查询条件，重新获取
    resetForm(formName) {
      if (formName === "queryForm") {
        this.query = {
          ProjectName: "",
          StartTime: "",
          EndTime: "",
          PageSize: 10,
          PageIndex: 1,
        };
        this.getData();
      } else if (formName === "postForm") {
        this.model.form = {
          ProjectName: "",
          Type: "",
          Price: "",
          Address: "",
          Remarks: "",
        };
      }
    },
    //新增
    postModel(formName) {
      this.$refs[formName].validate((success) => {
        if (success) {
          POINT.addPoint(this.model.form).then((res) => {
            if (res.status === "success") {
              this.model.visible = false;
              this.$message.success("添加成功");
              //重新获取
              this.getData();
              this.$store.dispatch("trip/setProjects");
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          this.$message.error("请补全信息");
        }
      });
    },
    //获取数据，带筛选条件
    getData() {
      POINT.getData(this.query).then((res) => {
        this.total = res.content.Total;
        this.tableData = res.content.OnePageData;
      });
    },
    //获取单个
    getDetail(row) {
      this.detail = this.deepClone(row);
      this.flag = 1;
    },
    //禁用，启用，删除
    changeState(Id, status) {
      switch (status) {
        case 0:
          POINT.enablePoint({ Id }).then((res) => {
            if (res.status === "success") {
              this.$message.success("修改成功");
            } else {
              this.$message.error("修改失败");
            }
          });
          break;
        case 1:
          POINT.disablePoint({ Id }).then((res) => {
            if (res.status === "success") {
              this.$message.success("修改成功");
            } else {
              this.$message.error("修改失败");
            }
          });
          break;
        case -1:
          POINT.deletePoint({ Id }).then((res) => {
            if (res.status === "success") {
              this.$message.success("修改成功");
            } else {
              this.$message.error("修改失败");
            }
          });
          break;
        default:
          break;
      }
      this.getData();
      this.$store.dispatch("trip/setRoutes");
    },
    //导出
    exportTable() {},
    //修改保存
    save(formName) {
      this.$refs[formName].validate().then((success) => {
        if (success) {
          POINT.updatePoint(this.detail).then((res) => {
            if (res.status === "success") {
              this.$message.success("修改成功");
              this.flag = 0; //修改成功，重新获取数据，修改flag
              this.getData();
              this.$store.dispatch("trip/setRoutes");
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          this.$message.error("请补全信息");
        }
      });
    },
    handlePageSize(value) {
      this.query.PageSize = value;
    },
    handlePageIndex(value) {
      this.query.PageIndex = value;
    },
   
  },
  created() {
    this.getData();
  },
  watch: {
    "query.PageSize": function () {
      this.getData();
    },
    "query.PageIndex": function () {
      this.getData();
    },
  },
};
</script>

<style scoped lang="less">
.main-left {
  width: 30%;
  border-right: 1px solid #ddd;
  min-width: 620px;
}
.main-left .left-table {
  height: 753px;
}
.main-left .left-pagination {
  height: 40px;
  background: #dedede;
  text-align: center;
}
.left-pagination .pagination-bottom {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}
.main-right {
  flex: 1;
}
.right-table {
  padding: 20px;
}
.input-form {
  width: 95%;
  border-collapse: collapse;
  border: 1px solid #aaa;
  thead {
    width: 100%;
    background-color: #f1f1f1;
    border: 1px solid #aaa;
  }
  th,
  tr {
    height: 33px;
    border: 1px solid #aaa;
  }
  td,
  th {
    text-align: center;
    vertical-align: middle;
    border: 1px solid #aaa;
  }
}
.input-form /deep/ .el-input__inner,
.input-form /deep/ .el-input-number,
.input-form /deep/ .el-select {
  border: none;
  width: 100%;
}
.picture-dialog /deep/ .el-carousel__item {
  text-align: center;
}
</style>
